export const advocateConsent = () => window.location.pathname === '/advocate_consent';

export const consentPage = () => window.location.pathname === '/corporate/consent'
  || advocateConsent();

/* eslint-disable complexity */
export const corporatePage = () => window.location.pathname.includes('corporate')
  || window.location.pathname.includes('/influitive/companies')
  || window.location.pathname.includes('forum/review')
  || window.location.pathname.includes('forum/admin')
  || window.location.host.startsWith('admin.');
/* eslint-enable complexity */

export const uxDebtPhase3Enabled = () => window._infl?.hub?.features?.includes('ux_debt_phase3');
export const badgesAndLevelsEnabled = window._infl?.hub?.features?.includes('badges_and_levels');
export const deleteMembersEnabled = window._infl?.hub?.features?.includes('delete_members');
export const isMdew = window._infl?.hub?.features?.includes('mountain_dew');
